"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerBackofficeStore = void 0;
var playerBackofficeStore_1 = require("./playerBackofficeStore");
Object.defineProperty(exports, "PlayerBackofficeStore", { enumerable: true, get: function () { return __importDefault(playerBackofficeStore_1).default; } });
